import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { Button } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { styleVariables } from '../../style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: ", ";\n  gap: 1rem;\n  ", "\n"])), function (_ref) {
  var $width = _ref.$width;
  return $width || '100%';
}, function (_ref2) {
  var $marginBottom = _ref2.$marginBottom;
  return $marginBottom || styleVariables.margin.medium;
}, function (_ref3) {
  var $hidden = _ref3.$hidden;
  return $hidden && "\n    display: none;\n  ";
});
var StyledLineContent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  gap: 8px;\n  scroll-behavior: smooth;\n  padding: ", " 0;\n\n  /* Hide scrollbar for WebKit */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for Firefox */\n  scrollbar-width: none;\n\n  /* Hide scrollbar for IE/Edge */\n  -ms-overflow-style: none;\n"])), styleVariables.padding.small);
export var LineCarouselWithArrow = function LineCarouselWithArrow(_ref4) {
  var children = _ref4.children,
      _ref4$scrollAmount = _ref4.scrollAmount,
      scrollAmount = _ref4$scrollAmount === void 0 ? 150 : _ref4$scrollAmount,
      hidden = _ref4.hidden,
      width = _ref4.width,
      marginBottom = _ref4.marginBottom;
  var scrollRef = useRef(null);

  var _useState = useState(false),
      canScrollLeft = _useState[0],
      setCanScrollLeft = _useState[1];

  var _useState2 = useState(false),
      canScrollRight = _useState2[0],
      setCanScrollRight = _useState2[1];

  var updateScrollButtons = useCallback(function () {
    var el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 2);
    setCanScrollRight(el.scrollLeft + el.clientWidth + 2 < el.scrollWidth);
  }, []);
  useEffect(function () {
    var el = scrollRef.current;
    if (!el) return;
    var resizeObserver = new ResizeObserver(function () {
      updateScrollButtons();
    });
    updateScrollButtons();
    el.addEventListener('scroll', updateScrollButtons);
    resizeObserver.observe(el);
    window.addEventListener('resize', updateScrollButtons);
    return function () {
      el.removeEventListener('scroll', updateScrollButtons);
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, [updateScrollButtons, width]);
  useEffect(function () {
    // Delay to ensure the DOM has been updated
    var timer = setTimeout(updateScrollButtons, 50);
    return function () {
      return clearTimeout(timer);
    };
  }, [children, updateScrollButtons]);

  var scroll = function scroll(direction) {
    var el = scrollRef.current;
    if (!el) return;
    var scrollDistance = direction === 'left' ? -scrollAmount : scrollAmount;
    el.scrollBy({
      left: scrollDistance,
      behavior: 'smooth'
    }); // Force re-check after animation completes

    setTimeout(updateScrollButtons, 350);
  };

  return /*#__PURE__*/_jsxs(StyledWrapper, {
    $hidden: hidden,
    $width: width,
    $marginBottom: marginBottom,
    children: [canScrollLeft && /*#__PURE__*/_jsx(Button, {
      size: "small",
      type: "text",
      icon: /*#__PURE__*/_jsx(LeftOutlined, {}),
      onClick: function onClick() {
        return scroll('left');
      },
      "aria-label": "Scroll left"
    }), /*#__PURE__*/_jsx(StyledLineContent, {
      ref: scrollRef,
      onLoad: updateScrollButtons,
      children: children
    }), canScrollRight && /*#__PURE__*/_jsx(Button, {
      size: "small",
      type: "text",
      icon: /*#__PURE__*/_jsx(RightOutlined, {}),
      onClick: function onClick() {
        return scroll('right');
      },
      "aria-label": "Scroll right"
    })]
  });
};